import dayjs from 'dayjs';
import * as yup from 'yup';

export const FilterConf = {
  schema: yup.object({
    start_date: yup
      .date()
      .nullable()
      .transform((value, originalValue) => {
        const parsedDate = dayjs(originalValue, 'YYYY-MM-DD', true);
        return parsedDate?.isValid() ? parsedDate.toDate() : null;
      }),
    end_date: yup
      .date()
      .nullable()
      .when('start_date', (start_date, schema) =>
        start_date
          ? schema.min(dayjs(start_date), "End date can't be before Start date")
          : schema
      )
      .transform((value, originalValue) => {
        const parsedDate = dayjs(originalValue, 'YYYY-MM-DD', true);
        return parsedDate?.isValid() ? parsedDate.toDate() : null;
      }),

  }),
  initialState: {
    start_date: null,
    end_date: null,
    id_department: null,
  },
};
